import { keys, reduce, isNil, isEmpty } from 'lodash';
import { Helpers, Validations } from '@utils/helpers';
import { IError } from '@utils/useForm';
import { CoverageForm } from '@models/SIO/Coverage.model';

export const validate = (values: CoverageForm) => {
  const fields = keys(values);
  const errors: any = reduce(fields, (result, field: string) => {
    return { ...result, [field]: validateField(values, field) };
  }, {});
  return errors;
}

export const validateField = (values: any, name: string) => {
  console.log(`QnB ➤ validateField(values, name) ➤`, { values, name, value: values[name] });
  const value = values[name];
  let error: IError | undefined = { isValid: true };
  switch (name) {
    case 'monthlyBenefit':
      if (isNil(value)) {
        error = { isValid: false };
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: `This field cannot be empty` };
        } else {
          const minPlanAssured = 200, maxPlanAssured = 5000, dividendSumAssured = 100;
          const planSumAssured = Number(value);
          const isOutOfAssured = Validations.isInRange(planSumAssured, minPlanAssured, maxPlanAssured);
          if (isOutOfAssured !== 0) {
            error = { isValid: false, message: `Please enter Monthly Benefit from ${Helpers.toCurrencyND(minPlanAssured)} to ${Helpers.toCurrencyND(maxPlanAssured)}` }
          } else {
            if (!Validations.isDivisible(planSumAssured, dividendSumAssured)) {
              error = { isValid: false, message: `Please enter Monthly Benefit in multiples of S$${dividendSumAssured}` }
            }
          }
        }
      }

      break;
    case 'planPremiumMode':
      if (isNil(value)) {
        error = { isValid: false };
      }
      break;
    case 'escBenefit':
    case 'premiumTermYears':
      if (!value) {
        error = { isValid: false }
      }
      break;
    case 'promoNric':
      if (isNil(value)) {
        error = { isValid: false }
      } else {
        if (isEmpty(value)) {
          //error = { isValid: false, message: 'This field cannot be empty' };
        } else {
          if (!Validations.isValidateFullNRIC(value.toUpperCase())) {
            error = { isValid: false, message: 'Please specify a valid NRIC number' };
          }
        }
      }
      break;
    case 'promoCode':
      // Hardcoded
      break;
  }
  return error;
}

export const validatePromoCode = (code: string): boolean => {
  return !isEmpty(code) && (code === 'SIO1' || code === 'SIO3')
}